export default {
  // List loading state (drives the Scheduled loader)
  loading: false,
  list: []
}